/* ***************************************************************** */
/* TODO: eslint pre-existing exceptions auto generated on 2022-09-08 */
/*       Do not add to these rule exceptions. Only remove as the     */
/*       violations are cleaned from our code.                       */
/*                                                                   */
/*       eslint-disable no-restricted-globals                        */
/*       eslint-disable eqeqeq                                       */
/* ***************************************************************** */
import React from 'react';
import Chart from 'react-apexcharts';
import { Box, Typography } from '@mui/material';
import { getRounded } from '../../lib/numbers';
import * as logger from '../../lib/logger';

const classes = {
  minMax: {
    marginTop: 2,
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  label: {
    py: 2,
    px: 1,
  },
};

const ApexChart = ({
  xLabel,
  yLabel,
  xUnits,
  stats,
  noAnimation,
  noRates,
  chartWidth,
  mapComponent = null,
  decimals = 2,
}) => {
  const options = {
    chart: {
      toolbar: {
        show: false,
      },
      height: 200,
      type: 'bar',
      events: {
        click(chart, w, e) {
          logger.info(chart, w, e);
        },
      },
      animations: {
        enabled: !noAnimation,
      },
    },
    colors: stats.colors,
    plotOptions: {
      bar: {
        columnWidth: '45%',
        distributed: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: [
        ...new Set(stats.chart.values.map((x) => x.label || 'Invalid')),
      ],
      labels: {
        style: {
          colors: [],
          fontSize: '12px',
        },
        formatter: (value) => {
          if (isNaN(value)) return value;
          return value.toLocaleString();
        },
      },
    },
    tooltip: {
      x: {
        show: !!xUnits,
        formatter: (value) => `${value} ${xUnits}`,
      },
      y: {
        title: {
          formatter: () => `${yLabel}: `,
        },
      },
    },
  };

  const regroupData = (values) => {
    const regrouped = [];
    const uniqueLabels = [...new Set(values.map((x) => x.label))];
    uniqueLabels.forEach((l) => {
      const vls = values.filter((x) => x.label == l).map((x) => x.value);
      const red = vls.reduce((a, b) => a + b);
      const resum = getRounded(red);
      regrouped.push({ label: l, value: resum });
    });
    return regrouped.map((x) => x.value);
  };

  const series = [{ name: xLabel, data: regroupData(stats.chart.values) }];

  return (
    <div>
      {!noRates && (
        <Box sx={classes.minMax}>
          <Typography variant="body1" sx={classes.label}>
            Min: {getRounded(stats.stats.min, decimals, true) || '0'}
          </Typography>
          <Typography variant="body1" sx={classes.label}>
            Max: {getRounded(stats.stats.max, decimals, true)}
          </Typography>
          <Typography variant="body1" sx={classes.label}>
            Avg: {getRounded(stats.stats.avg, decimals, true)}
          </Typography>
          {stats.stats.std && (
            <Typography variant="body1" sx={classes.label}>
              STD: {getRounded(stats.stats.std, decimals, true)}
            </Typography>
          )}
        </Box>
      )}
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ position: 'relative', width: chartWidth || 'auto' }}>
          <p
            style={{
              position: 'absolute',
              left: 0,
              transform: 'rotate(-90deg)',
              textAlign: 'center',
              top: 'calc(50% - 30px)',
            }}
          >
            {yLabel}
          </p>
          <div style={{ padding: 30, paddingTop: 0 }}>
            <Chart options={options} series={series} type="bar" />
          </div>
          <p
            style={{
              position: 'absolute',
              bottom: 0,
              left: 'calc(50% - 30px)',
            }}
          >
            {xLabel}
          </p>
        </div>
        {mapComponent ? <div>{mapComponent}</div> : null}
      </div>
    </div>
  );
};

export default ApexChart;
